import { PushNotifications } from "@capacitor/push-notifications";
import { getNativePlatform, isNativePlatform } from "./platform";

export type PushRegistrationHandler = (payload: {
  token: string;
  platform: "ios" | "android";
}) => void | Promise<void>;

export async function initPushNotifications(
  onRegistration: PushRegistrationHandler,
): Promise<() => void> {
  if (!isNativePlatform()) {
    return () => undefined;
  }

  const platform = getNativePlatform();
  if (platform !== "ios" && platform !== "android") {
    return () => undefined;
  }

  let permission = await PushNotifications.checkPermissions();
  if (permission.receive === "prompt") {
    permission = await PushNotifications.requestPermissions();
  }

  if (permission.receive !== "granted") {
    return () => undefined;
  }

  const registrationListener = await PushNotifications.addListener(
    "registration",
    (event) => {
      void onRegistration({ token: event.value, platform });
    },
  );

  const registrationErrorListener = await PushNotifications.addListener(
    "registrationError",
    (error) => {
      console.error("Push registration failed", error);
    },
  );

  const pushActionListener = await PushNotifications.addListener(
    "pushNotificationActionPerformed",
    (notification) => {
      console.info("Push notification opened", notification);
    },
  );

  await PushNotifications.register();

  return () => {
    void registrationListener.remove();
    void registrationErrorListener.remove();
    void pushActionListener.remove();
  };
}
